import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { X } from 'lucide-react';
import LangEnum from '../../lang/LangEnum';
import { AnnouncementBarTestIds } from '../../utils/testIds/Announcements.testIds';
import { useTranslation } from '../translation/TranslationContext';
import { useAnnouncementBarStyles } from './announcementBar.styles';

interface AnnouncementBarProps {
  barText: string;
  onLearnMore?: () => void;
  onDismiss?: () => void;
}

const AnnouncementBar = ({ barText, onLearnMore, onDismiss }: AnnouncementBarProps) => {
  const { classes } = useAnnouncementBarStyles();
  const { translate } = useTranslation();

  return (
    <Box className={classes.root} test-id={AnnouncementBarTestIds.BAR}>
      <Box className={classes.message}>
        <Box
          component="img"
          src="/images/teceo-symbol-white.svg"
          alt=""
          className={classes.symbol}
        />

        <Typography variant="body1" noWrap>
          {barText}
        </Typography>

        <Typography
          className={classes.learnMore}
          testId={AnnouncementBarTestIds.LEARN_MORE}
          role="button"
          tabIndex={0}
          variant="body2"
          onClick={onLearnMore}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              onLearnMore?.();
            }
          }}
        >
          {translate(LangEnum.ANNOUNCEMENT_LEARN_MORE)}
        </Typography>
      </Box>

      <IconButton
        icon={X}
        size="medium"
        className={classes.dismiss}
        testId={AnnouncementBarTestIds.DISMISS}
        ariaLabel={translate(LangEnum.ANNOUNCEMENT_DISMISS)}
        onClick={onDismiss}
      />
    </Box>
  );
};

export default AnnouncementBar;
